
function isNotEmpty<DataType>(data: DataType[]): data is [DataType, ...DataType[]] {
    return data.length !== 0;
}

export default isNotEmpty;
